<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <el-date-picker
        v-model="value"
        :format="format"
        :placeholder="placeholder ? placeholder : 'Select date'"
        :type="pickerType"
        :value-format="valueFormat"
        @blur="blur"
        @change="change"
      />
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    pickerType: {
      type: String,
      default: "date",
    },

    format: {
      type: String,
      default: "dd MMM yyyy",
    },

    valueFormat: {
      type: String,
    },
  },

  watch: {
    pickerType() {
      this.format = this.getCurrentPickerType();
    },
  },

  created() {
    this.format = this.getCurrentPickerType();
  },

  methods: {
    change(value) {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("input", value);
      this.$emit("change", value);
    },

    blur(value) {
      if (value.userInput && value.userInput.length > 0) {
        /* eslint-disable no-param-reassign */
        value.userInput = null;

        window.toastr.warning(
          "Custom input for Date field is not allowed, reverting to previous value.",
          "Warning"
        );
      }
    },

    getCurrentPickerType() {
      switch (this.pickerType) {
        case "month":
          return "MMM yyyy";

        case "year":
          return "yyyy";

        default:
          return "dd MMM yyyy";
      }
    },
  },
};
</script>
